/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { Table } from 'components/composite';
import { Spacer, Field, Col } from '@cleartrip/bento';
import { ReactComponent as Chevron } from 'assets/icons/chevron.svg';
import Clevertap from 'analytics'
import { FilterContext } from 'context/travelsafe';

function StateQuarantine({ states }) {
	const [statesList, setStatesList] = useState([]);
	const [filter] = useContext(FilterContext);
	const [value, setValue] = useState('');
	const [showMore, setShowMore] = useState(true);
  const [arrayLimit, setArrayLimit] = useState(5);

	useEffect(() => {
		setStatesList(states);
	}, [states]);

	function filterResults(e) {
		const sParm = e.target.value;
		Clevertap.event('Air_UI_action', {
			action_name: 'airport_search',
			value:sParm
		})
		setValue(sParm);
	}

	function showAll() {
		Clevertap.event('Air_UI_action', {
			action_name: 'view_quarantine_states',
		})
		setShowMore(!showMore);
		setArrayLimit(states.length);
		setStatesList(states);
	}

	useEffect(() => {
		if (value.length === 0) {
			setShowMore(true);
			setArrayLimit(5);
		} else {
			setShowMore(false);
			setArrayLimit(states.length);
		}
		let filteredArr = states.filter(
			(item) => item.name.toLowerCase().includes(value.toLowerCase()) || item.airports.toLowerCase().includes(value.toLowerCase())
		);
		setStatesList(filteredArr);

		if (states.length < 5) setShowMore(false);
	}, [value, states]);

	return (
		<>
			{!filter.isFilterApplied && (
				<Col span={18} xs={24} className='pl-0 mb-5'>
					<Field
						size='lg'
						onChange={(e) => filterResults(e)}
						value={value}
						placeholder='Search by state, city, or airport code'
					/>
				</Col>
			)}
			<Table>
				<Table.Head className='bg-neutral-0 c-neutral-700 fs-2 br-4 mb-2 flex flex-middle d-none--xs'>
					<Table.Column span={4} className='py-2 pl-4 d-none--sm d-none--xs'>
						State
					</Table.Column>
					<Table.Column span={5} className='py-2 pl-3 d-none--sm d-none--xs'>
					Mandatory home quarantine
					</Table.Column>
					<Table.Column span={3} className='py-2  pl-3 d-none--sm d-none--xs'>
						Duration (days)
					</Table.Column>
					<Table.Column span={6} className='py-2 pl-3 d-none--sm d-none--xs'>
						Applicable to
					</Table.Column>
					<Table.Column span={6} className='py-2 pl-3 d-none--sm d-none--xs'>
						Mandatory documents
					</Table.Column>
				</Table.Head>
			</Table>
			<Table xs={24} >
				{statesList &&
					statesList.slice(0, arrayLimit).map((state, index) => {
						return (
							<Table.Row
								className='mx-0 py-1--xs pt-3 pb-3 py-3--xs c-neutral-700 fs-3 c-pointer hover:elevation-3'
								key={index}
								dotlist={state.details}
								bottomlist={state.airports}
								active = {filter.isFilterApplied || statesList.length < 3}
							>
								<Table.Column span={4} xs={24} className='py-1 pl-4 px-4--xs fw-700 flex flex-between'>
									<span>{state.name}</span>
									<span className='p-relative d-none d-block--xs'>
										<div className='flex'>
											<span className='chevron-text pr-1'>Details</span>
											<Chevron height={16} width={12} className='chevron c-secondary-500' />
										</div>
									</span>
								</Table.Column>
								<Table.Column span={5} xs={24} className="py-1 px-4--xs">
									<span className='d-none d-block--xs'>Home quarantine:</span>
									<span>&nbsp;{state.is_institutional}</span>
									{state.institutional_length !== '-' ? (
										<span className='d-none d-block--xs'>, {state.institutional_length} days</span>
									) : (
										<span></span>
									)}
								</Table.Column>
								<Table.Column span={3} xs={24} className='d-none--xs py-1'>
									{state.institutional_length}
								</Table.Column>
								<Table.Column span={6} xs={24} className='d-none--xs py-1'>
									{state.institutional_length_applicable}
								</Table.Column>
								<Table.Column span={6} xs={24} className='d-none d-block--xs py-1 px-4--xs'>
									Applicable to: {state.institutional_length_applicable}
								</Table.Column>
								<Table.Column span={6} xs={24} className='d-none d-block--xs py-1 px-4--xs'>
									<span className='c-neutral-400'>Mandatory documents needed:</span>
									<br />
									<Spacer className='pt-1' />
									{state.mandatory_documents}
								</Table.Column>
								<Table.Column span={6} xs={24} className='py-1 pr-7 flex flex-between flex-middle d-none--xs'>
									{state.mandatory_documents}
									<Chevron height={16} width={12} className='chevron d-none--xs c-secondary-500' />
								</Table.Column>
							</Table.Row>
						);
					})}
			</Table>
			<Spacer className='pt-2' />
			{showMore ? (
				<span class='c-pointer c-secondary-500 fw-500 fs-3 td-none hover:td-underline' onClick={showAll}>
					View all {states.length - arrayLimit} states/UTs
				</span>
			) : (
				<span></span>
			)}
		</>
	);
}

export default StateQuarantine;
